var _defs, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gearNavGradient",
    gradientTransform: "rotate(300)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#F8A305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    stopColor: "#F51504"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "navigation__gear-fill",
    d: "M12 2.5 L15.5 5.9 L20.2 7.3 L19 12 L20.2 16.7 L15.5 18.1 L12 21.5 L8.5 18.1 L3.8 16.7 L5 12 L3.8 7.3 L8.5 5.9 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "navigation__gear-hole",
    cx: 12,
    cy: 12,
    r: 3.25,
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.9c833652ef5633ff557040249e3f17da.svg";
export { ForwardRef as ReactComponent };